module.exports = "/images/vi.svg";